"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurePartnerAssets = exports.configureInstructorAssets = exports.configureSessionLightAssets = exports.configureSessionAssets = exports.configureCourseLightAssets = exports.configureCourseAssets = exports.configureURL = void 0;
function configureURL(baseUrl = '', dbUrl = '', forceToWebp = false) {
    const schemeRegex = /^[a-z0-9]+:\/\//i;
    function appendExtension(str, extension) {
        const extensionRegex = /.(jpg|jpeg|png|gif)$/;
        if (extensionRegex.test(str)) {
            return str + extension;
        }
        return str;
    }
    const isFull = schemeRegex.test(dbUrl);
    let url = dbUrl;
    if ((isFull && !baseUrl) || (!isFull && !baseUrl)) {
        url = dbUrl;
    }
    else if (isFull && baseUrl) {
        const finalUrl = new URL(baseUrl);
        finalUrl.pathname = new URL(dbUrl).pathname;
        url = finalUrl.toString();
    }
    else if (!isFull && baseUrl) {
        const finalUrl = new URL(baseUrl);
        finalUrl.pathname = dbUrl;
        url = finalUrl.toString();
    }
    if (forceToWebp) {
        return appendExtension(url, '.webp');
    }
    return url;
}
exports.configureURL = configureURL;
function configureCourseAssets(course, assetsConfig = null) {
    if (!assetsConfig || !course) {
        return course;
    }
    course.previewUrl = configureURL(assetsConfig.staticAssetsBaseUrl, course.previewUrl, assetsConfig.forceToWebp);
    course.bannerUrl = configureURL(assetsConfig.staticAssetsBaseUrl, course.bannerUrl, assetsConfig.forceToWebp);
    const sessions = {};
    Object.keys(course.sessions).forEach((sessionId) => {
        sessions[sessionId] = configureSessionAssets(course.sessions[sessionId], assetsConfig);
    });
    course.instructors = course.instructors.map((instructor) => configureInstructorAssets(instructor, assetsConfig));
    course.contributorPartners = course.contributorPartners.map((partner) => configurePartnerAssets(partner, assetsConfig));
    course.collaborationPartners = course.collaborationPartners.map((partner) => configurePartnerAssets(partner, assetsConfig));
    return course;
}
exports.configureCourseAssets = configureCourseAssets;
function configureCourseLightAssets(course, assetsConfig = null) {
    if (!assetsConfig || !course) {
        return course;
    }
    course.previewUrl = configureURL(assetsConfig.staticAssetsBaseUrl, course.previewUrl, assetsConfig.forceToWebp);
    const sessions = {};
    Object.keys(course.sessionLight).forEach((sessionId) => {
        sessions[sessionId] = configureSessionLightAssets(course.sessionLight[sessionId], assetsConfig);
    });
    return course;
}
exports.configureCourseLightAssets = configureCourseLightAssets;
function configureSessionAssets(session, assetsConfig = null) {
    if (!assetsConfig || !session) {
        return session;
    }
    session.brochureUrl = configureURL(assetsConfig.brochureBaseUrl, session.brochureUrl, assetsConfig.forceToWebp);
    session.previewUrl = configureURL(assetsConfig.staticAssetsBaseUrl, session.previewUrl, assetsConfig.forceToWebp);
    session.bannerUrl = configureURL(assetsConfig.staticAssetsBaseUrl, session.bannerUrl, assetsConfig.forceToWebp);
    session.instructors = session.instructors.map((instructor) => configureInstructorAssets(instructor, assetsConfig));
    session.relatedSession = session.relatedSession.map((s) => configureSessionLightAssets(s, assetsConfig));
    session.collaborationPartners = session.collaborationPartners.map((s) => configurePartnerAssets(s, assetsConfig));
    session.contributorPartners = session.contributorPartners.map((partner) => configurePartnerAssets(partner, assetsConfig));
    return session;
}
exports.configureSessionAssets = configureSessionAssets;
function configureSessionLightAssets(session, assetsConfig = null) {
    if (!assetsConfig || !session) {
        return session;
    }
    session.previewUrl = configureURL(assetsConfig.staticAssetsBaseUrl, session.previewUrl, assetsConfig.forceToWebp);
    return session;
}
exports.configureSessionLightAssets = configureSessionLightAssets;
function configureInstructorAssets(instructor, assetsConfig = null) {
    if (!assetsConfig || !instructor) {
        return instructor;
    }
    instructor.imageUrl = configureURL(assetsConfig.staticAssetsBaseUrl, instructor.imageUrl || '', assetsConfig.forceToWebp);
    instructor.sessionInstructor = instructor.sessionInstructor.map((instructor) => configureSessionLightAssets(instructor, assetsConfig));
    return instructor;
}
exports.configureInstructorAssets = configureInstructorAssets;
function configurePartnerAssets(partner, assetsConfig = null) {
    if (!assetsConfig || !partner) {
        return partner;
    }
    partner.imageUrl = configureURL(assetsConfig.staticAssetsBaseUrl, partner.imageUrl || '', assetsConfig.forceToWebp);
    partner.sessionCollaboration = partner.sessionCollaboration.map((session) => configureSessionLightAssets(session, assetsConfig));
    partner.sessionCollaboration = partner.sessionContributor.map((session) => configureSessionLightAssets(session, assetsConfig));
    return partner;
}
exports.configurePartnerAssets = configurePartnerAssets;
//# sourceMappingURL=assets.js.map